export default __webpack_public_path__ + "static/media/add-dependent-banner_add-dependents.b350066b.png";